import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { AppShell } from '@/shared/ui/app-shell'
import { PageHeader, PageHeaderSpacer } from '@/shared/ui/page-header'
import { useBackButton } from '@/shared/lib/telegram'

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
})

/**
 * Страница политики конфиденциальности
 * 
 * Юридическая страница с информацией об обработке персональных данных.
 */
function PrivacyPage() {
  const navigate = useNavigate()

  // Нативная кнопка "Назад" → профиль
  useBackButton(true, () => navigate({ to: '/profile' }))

  return (
    <AppShell showBottomNav={false}>
      <PageHeader 
        title="Политика конфиденциальности"
        hideBackButton
      />

      <PageHeaderSpacer />

      <main className="content-container pb-6">
        <div className="prose prose-sm dark:prose-invert max-w-none animate-in fade-in duration-300">
          <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
            Настоящая Политика конфиденциальности персональных данных действует в отношении всей информации, которую сайт чайного клуба «Дракон и Сорока», расположенный на доменном имени drakonisoroka.ru, может получить о Пользователе во время использования сайта, программ и продуктов Интернет-магазина.
          </p>

          <Section title="1. Определение терминов">
            <p>
              <strong>1.1.</strong> «Администрация сайта Интернет-магазина» – уполномоченные сотрудники на управление сайтом, действующие от имени Чайного клуба «Дракон и Сорока», которые организуют и (или) осуществляют обработку персональных данных.
            </p>
            <p>
              <strong>1.2.</strong> «Персональные данные» — любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных).
            </p>
            <p>
              <strong>1.3.</strong> «Обработка персональных данных» — любое действие (операция) или совокупность действий, совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными.
            </p>
          </Section>

          <Section title="2. Общие положения">
            <p>
              <strong>2.1.</strong> Использование Пользователем сайта Интернет-магазина означает согласие с настоящей Политикой конфиденциальности и условиями обработки персональных данных Пользователя.
            </p>
            <p>
              <strong>2.2.</strong> В случае несогласия с условиями Политики конфиденциальности Пользователь должен прекратить использование сайта Интернет-магазина.
            </p>
          </Section>

          <Section title="3. Предмет политики конфиденциальности">
            <p>
              <strong>3.1.</strong> Настоящая Политика конфиденциальности устанавливает обязательства Администрации сайта по неразглашению и обеспечению режима защиты конфиденциальности персональных данных.
            </p>
            <p>
              <strong>3.2.</strong> Персональные данные, разрешённые к обработке:
            </p>
            <ul className="list-disc list-inside space-y-1 text-gray-600 dark:text-gray-400">
              <li>фамилию, имя, отчество Пользователя;</li>
              <li>контактный телефон Пользователя;</li>
              <li>адрес электронной почты (e-mail);</li>
              <li>адрес доставки Товара;</li>
              <li>место жительство Пользователя.</li>
            </ul>
          </Section>

          <Section title="4. Цели сбора персональной информации">
            <p>Персональные данные Пользователя Администрация может использовать в целях:</p>
            <ul className="list-disc list-inside space-y-1 text-gray-600 dark:text-gray-400">
              <li>Идентификации Пользователя для оформления заказа;</li>
              <li>Предоставления доступа к персонализированным ресурсам;</li>
              <li>Установления обратной связи с Пользователем;</li>
              <li>Уведомления о состоянии Заказа;</li>
              <li>Предотвращения мошенничества.</li>
            </ul>
          </Section>

          <Section title="5. Способы и сроки обработки">
            <p>
              <strong>5.1.</strong> Обработка персональных данных осуществляется без ограничения срока, любым законным способом.
            </p>
            <p>
              <strong>5.2.</strong> Пользователь соглашается с тем, что Администрация вправе передавать персональные данные третьим лицам (курьерским службам, организациям почтовой связи) исключительно в целях выполнения заказа.
            </p>
          </Section>

          <Section title="6. Обязательства сторон">
            <p><strong>Пользователь обязан:</strong></p>
            <ul className="list-disc list-inside space-y-1 text-gray-600 dark:text-gray-400 mb-4">
              <li>Предоставить информацию о персональных данных;</li>
              <li>Обновить информацию в случае изменения.</li>
            </ul>
            <p><strong>Администрация обязана:</strong></p>
            <ul className="list-disc list-inside space-y-1 text-gray-600 dark:text-gray-400">
              <li>Использовать информацию исключительно для указанных целей;</li>
              <li>Обеспечить хранение конфиденциальной информации в тайне.</li>
            </ul>
          </Section>
        </div>
      </main>
    </AppShell>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="mt-6">
      <h3 className="text-base font-semibold text-ink dark:text-white mb-3">
        {title}
      </h3>
      <div className="text-gray-600 dark:text-gray-400 leading-relaxed space-y-2">
        {children}
      </div>
    </div>
  )
}


























